import { useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout';
import { useRefetchWhenCatalogChanges } from '../contexts/AdminCatalogContext';
import { getLideresPorExperiencia, type RankingPeriodo } from '../lib/guiaRanking';

export default function RankingPage() {
  const [periodo, setPeriodo] = useState<RankingPeriodo>('mensal');
  const [refreshKey, setRefreshKey] = useState(0);
  void refreshKey;
  useRefetchWhenCatalogChanges(() => setRefreshKey((k) => k + 1));
  const lideresPorExperiencia = getLideresPorExperiencia(periodo);

  return (
    <AdminLayout>
      <div className="w-full">
        <div className="sticky top-0 z-20 px-4 sm:px-6 py-6 border-b border-gray-200 bg-white shadow-sm">
          <nav className="text-sm text-gray-500 mb-1">
            <Link to="/dashboard" className="hover:text-gray-700">Home</Link>
            {' > '}
            <Link to="/ranking" className="hover:text-gray-700">Ranking</Link>
          </nav>
          <div className="flex items-center justify-between flex-wrap gap-2">
            <h1 className="text-xl sm:text-2xl font-bold text-gray-900">Ranking de Guias</h1>
            <div className="flex items-center gap-2 flex-wrap">
              <div className="inline-flex rounded-lg border border-gray-300 bg-white p-1">
                <button
                  type="button"
                  onClick={() => setPeriodo('mensal')}
                  className={`px-3 py-1.5 text-sm rounded-md ${periodo === 'mensal' ? 'bg-orange-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`}
                >
                  Ranking Mensal
                </button>
                <button
                  type="button"
                  onClick={() => setPeriodo('anual')}
                  className={`px-3 py-1.5 text-sm rounded-md ${periodo === 'anual' ? 'bg-orange-500 text-white' : 'text-gray-700 hover:bg-gray-100'}`}
                >
                  Ranking Anual
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 sm:px-6 py-6 space-y-4">
          <div className="bg-white rounded-xl border border-gray-200 p-4">
            <h2 className="text-base font-semibold text-gray-900 mb-1">Líder por experiência</h2>
            <p className="text-sm text-gray-600">
              Terapia: líder por <strong>pessoas atendidas</strong>. Guia/tour: líder por <strong>3 pontos por dia + 1 por pessoa</strong>.
            </p>
          </div>

          <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-x-auto">
            <table className="w-full min-w-[900px] text-sm">
              <thead>
                <tr className="bg-orange-500 text-white">
                  <th className="text-left py-3 px-4 font-semibold">Experiência</th>
                  <th className="text-left py-3 px-4 font-semibold">Tipo</th>
                  <th className="text-left py-3 px-4 font-semibold">Primeiro</th>
                  <th className="text-left py-3 px-4 font-semibold">Segundo</th>
                  <th className="text-left py-3 px-4 font-semibold">Terceiro</th>
                </tr>
              </thead>
              <tbody>
                {lideresPorExperiencia.map((r, idx) => (
                  <tr key={r.experienciaId} className={`${['bg-white', 'bg-gray-50', 'bg-orange-50'][idx % 3]} border-b border-gray-100 hover:opacity-90 transition-opacity`}>
                    <td className="py-3 px-4 text-gray-900">{r.experienciaNome}</td>
                    <td className="py-3 px-4">
                      <span className={`inline-flex px-2 py-0.5 rounded text-xs font-medium ${r.tipoRanking === 'terapia' ? 'bg-purple-100 text-purple-800' : 'bg-blue-100 text-blue-800'}`}>
                        {r.tipoRanking === 'terapia' ? 'Terapia' : 'Guia'}
                      </span>
                    </td>
                    <td className="py-3 px-4 text-gray-900">
                      <span className="inline-flex px-2 py-0.5 rounded text-xs font-medium bg-orange-100 text-orange-800">
                        {r.primeiroPontos} pts
                      </span>
                      <span className="ml-2">{r.primeiroNome}</span>
                    </td>
                    <td className="py-3 px-4 text-gray-900">
                      {r.segundoPontos != null ? (
                        <>
                          <span className="inline-flex px-2 py-0.5 rounded text-xs font-medium bg-orange-100 text-orange-800">
                            {r.segundoPontos} pts
                          </span>
                          <span className="ml-2">{r.segundoNome}</span>
                        </>
                      ) : (
                        '—'
                      )}
                    </td>
                    <td className="py-3 px-4 text-gray-900">
                      {r.terceiroPontos != null ? (
                        <>
                          <span className="inline-flex px-2 py-0.5 rounded text-xs font-medium bg-orange-100 text-orange-800">
                            {r.terceiroPontos} pts
                          </span>
                          <span className="ml-2">{r.terceiroNome}</span>
                        </>
                      ) : (
                        '—'
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {lideresPorExperiencia.length === 0 && (
              <div className="p-8 text-center text-gray-500">Sem experiências para calcular liderança.</div>
            )}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
